import checkout from "./form";

const {
  formField: {
    settlement,
    year,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxpayerInstead,
    taxpayerInsteadId,
    certificate,
    fullName,
    firstTime,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [settlement.name]: "",
  [year.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxpayerInstead.name]: "",
  [taxpayerInsteadId.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
